import * as React from "react"
import { FaVideo, FaVideoSlash } from "react-icons/fa"
import Dropdown from "../common/dropdown"
import {
  SettingsBodyTitle,
  InputWrapper,
  Input,
  ControlButton
} from "./settings.styled"
import { SettingCameraProps } from "./settings.interfaces"
import { useResizeObserver } from "../../hooks/useResizeObserver"
import useWindowSize from "../../hooks/useWindowSize"
import { useTranslation } from "react-i18next"
import DeniedPermissionWarning from "./DeniedPermissionWarning"
import { Flex } from "@chakra-ui/layout"

const _SettingCamera: React.FC<SettingCameraProps> = ({
  isShowFullView,
  roomStyles,
  handleChangeMuteDevice,
  currentMutedDevices,
  handleChangeDevice,
  devicesLists,
  currentVideo,
  videoTrack,
  isHomePage,
  сolorBorder,
  devicePermissionDenied
}) => {
  const { t } = useTranslation()
  // const _stylingDisabledIcon: React.CSSProperties = React.useMemo(() => {
  //   return {
  //     opacity: 0.5
  //   }
  // }, [])

  const { screenSize } = useWindowSize()
  const isSmallWindowHeight = React.useMemo(
    () => 570 > screenSize.height || screenSize.width < 1024,
    [screenSize.height, screenSize.width]
  )

  const inputWrapper = React.useRef<HTMLDivElement>(null)
  const [widthInputWrapper] = useResizeObserver(inputWrapper)

  return (
    <>
      <SettingsBodyTitle
        isSmallWindowHeight={isSmallWindowHeight && isShowFullView}
        roomStyles={roomStyles}
        isHomePage={isHomePage}
      >
        {!isShowFullView && (
           <Flex marginRight="15px">
            <DeniedPermissionWarning isDenied={devicePermissionDenied?.video} top="-14px" right="0px">
              <ControlButton
                roomStyles={roomStyles}
                isHomePage={isHomePage}
                type="button"
                onClick={() =>
                  handleChangeMuteDevice("video", !currentMutedDevices.video)
                }
                // disabled={videoTrack ? false : true}
                // style={videoTrack ? null : _stylingDisabledIcon}
              >
                {currentMutedDevices.video ? <FaVideoSlash color={roomStyles?.joinPageButtonTextColor} /> : <FaVideo color={roomStyles?.joinPageButtonTextColor} />}
              </ControlButton>

            </DeniedPermissionWarning>
           </Flex>

        )}
        {t("Camera")}
      </SettingsBodyTitle>
      <InputWrapper
        ref={inputWrapper}
        isSmallWindowHeight={isSmallWindowHeight && isShowFullView}
      >
        <Dropdown
          label={t("Cams")}
          roomStyles={!isHomePage && roomStyles}
          onChange={item => handleChangeDevice("video", item)}
          list={devicesLists.video}
          emptyText={t("Empty devices")}
          сolorBorder={сolorBorder}
          customstyles={{
            item: {
              width: `${widthInputWrapper - 4}px`
            },
            button: {
              padding:
                isSmallWindowHeight && isShowFullView && "0.3rem 0.75rem",
              fontSize: isSmallWindowHeight && isShowFullView && "0.9rem"
            }
          }}
        />
        <Input
          type="text"
          disabled
          isSmallWindowHeight={isSmallWindowHeight && isShowFullView}
          value={currentVideo?.label || t("No camera")}
          style={
            !isHomePage
              ? {
                  border: `2px solid ${сolorBorder}`,
                  backgroundColor: roomStyles.servicePanelElementBackground,
                  color: roomStyles?.servicePanelElementPrimaryText,
                  borderLeft: "none"
                }
              : {}
          }
        />
      </InputWrapper>
    </>
  )
}

export const SettingCamera = _SettingCamera
